import axios from 'axios'
import { MethodType, TIMEOUT } from '../constants/MethodType'
import { store } from '../store/index'
import { setErrorMsg } from '../store/handleErrorSlice'
import { ROUTES } from '../constants/Routing'
import { setLogoutAdmin } from '../store/adminSlice'
import { setLogout } from '../store/userSlice'

const GENBI_API = 'https://lndata-genbi-api.lndata.com'
const GENBI_HEADERS = { 'Content-Type': 'application/json', 'X-Access-Token': 'FqDmqNtkXMe2qCrk' }

export const request = async (type = 1, api, method = MethodType.GET, params = {}, header = {}, forceNoToken, extraConf = {}, errException = []) => {
  const { user, admin } = store.getState() || {}
  const { nowBrand, nowGroup } = user || {}
  const pathname = window.location.pathname
  const userToken = user.token
  const adminToken = admin.token
  const adminMode = pathname.includes(ROUTES.ADMIN_ROOT)
  const token = forceNoToken ? {} : adminMode ? { 'x-admin-token': adminToken } : { 'X-Auth-Token': userToken }

  const isGenbiApi = type === 3
  const conf = {
    timeout: TIMEOUT,
    headers: isGenbiApi
      ? GENBI_HEADERS
      : {
          'Content-Type': 'application/json',
          'x-cdp-group': nowGroup,
          'x-cdp-brand': nowBrand,
          ...header,
          ...token
        },
    ...extraConf
  }

  const apiRoot = isGenbiApi ? GENBI_API : `${window.location.origin}/${type === 1 ? 'frontend_api' : 'backend_api'}`
  const data = (method === 'GET') ? 'params' : 'data'

  try {
    const result = await axios({
      url: `${apiRoot}${api}`,
      method,
      [data]: params,
      ...conf
    })
    return result
  } catch (error) {
    const { data, status: errStatus } = error?.response || {}
    const { message: msg, code } = data || {}
    if (errException.includes(errStatus)) return error?.response
    const errMsg = type === 1 ? msg : '後端呼叫失敗'

    store.dispatch(setErrorMsg({ catchError: true, errStatus, errMessage: errMsg, errCode: code }))

    const loginPath = adminMode ? ROUTES.ADMIN_LOGIN : ROUTES.CLIENT_LOGIN
    const isLogin = pathname === loginPath || pathname === `${loginPath}/`
    if (errStatus === 401 && !isLogin) {
      store.dispatch(adminMode ? setLogoutAdmin() : setLogout())
      window.location.pathname = adminMode ? ROUTES.ADMIN_LOGIN : ROUTES.CLIENT_LOGIN
    }
  }
}
